// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"a2-z"};